import React, { forwardRef, memo, useMemo } from "react";
import { View, StyleSheet } from "react-native";

type TabListProps = {
  children?: React.ReactNode;
  orientation?: "horizontal" | "vertical";
  variant?: "scrollable" | null;
};

export const TabList = memo(
  forwardRef<View, TabListProps>(
    ({ children, orientation = "horizontal", variant, ...props }, ref) => {
      let tabIndex = 0;

      const modifiedTabList = useMemo(() => {
        return React.Children.toArray(children).map((child) =>
          React.isValidElement(child)
            ? React.cloneElement(child, {
                key: child.key ?? `tab-${tabIndex}`,
                value: `tab-${tabIndex++}`,
                ...child.props,
              })
            : child,
        );
      }, [children]);

      const containerStyle = [
        styles.container,
        orientation === "vertical" ? styles.vertical : styles.horizontal,
        orientation === "horizontal" &&
          variant === "scrollable" &&
          styles.scrollHorizontal,
        orientation === "vertical" &&
          variant === "scrollable" &&
          styles.scrollVertical,
      ];

      return (
        <View ref={ref} style={containerStyle} {...props}>
          {modifiedTabList}
        </View>
      );
    },
  ),
);

const styles = StyleSheet.create({
  container: {},
  horizontal: {
    flexDirection: "row",
    overflow: "hidden",
  },
  scrollHorizontal: {
    overflowX: "scroll",
  },
  scrollVertical: {
    overflowY: "scroll",
  },
  vertical: {
    flexDirection: "column",
    overflow: "hidden",
  },
});
